/** Small red count pill for unread indicators (chat buttons, nav tabs, rows). */
export function UnreadBadge({ count, style }: { count: number; style?: React.CSSProperties }) {
  if (!count || count < 1) return null;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      minWidth: 16, height: 16, padding: '0 4px', borderRadius: 8,
      background: '#e74c3c', color: '#fff', fontSize: 10, fontWeight: 700, lineHeight: 1,
      ...style,
    }}>{count > 9 ? '9+' : count}</span>
  );
}
